import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './company/Logo';
import ZimletMegaMenu from './navigation/ZimletMegaMenu';
import MobileNav from './navigation/MobileNav';
import LanguageSwitcher from './common/LanguageSwitcher';
import ContactButton from './navigation/ContactButton';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`relative w-full transition-all duration-500 border-b ${
        isScrolled
          ? 'bg-slate-950/85 backdrop-blur-xl border-white/10 shadow-[0_10px_40px_-10px_rgba(2,6,23,0.8)]'
          : 'bg-slate-950/60 backdrop-blur-md border-white/5'
      }`}
    >
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Logo size="sm" />

          <div className="hidden md:flex items-center gap-4">
            <LanguageSwitcher />
            <ContactButton />
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isOpen}
            className="md:hidden text-slate-200 p-2 rounded-lg border border-white/10 hover:bg-white/10 transition-colors"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      <div className="hidden md:block">
        <ZimletMegaMenu />
      </div>

      <MobileNav isOpen={isOpen} onNavigate={() => setIsOpen(false)} />
    </header>
  );
};

export default Navbar;
